module.exports = __webpack_public_path__ + "img/favicon.19a24bc4.png";